var _style, _defs, _polyline, _line, _line2, _line3, _defs2, _defs3, _rect, _defs4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000012434582861495914950000005146518294698015110_);}\n\t.st1{fill:none;stroke:#FFFFFF;stroke-width:2;stroke-miterlimit:10;}\n\t.st2{clip-path:url(#SVGID_00000146466318050045771850000011945401771269268412_);}\n\t.st3{clip-path:url(#SVGID_00000084529611089595565210000004701890166199537825_);}\n\t.st4{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Brochure-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 3,
    y: 3,
    width: 26,
    height: 26
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000169540543821450095670000005932053822762790586_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000169540543821450095670000005932053822762790586_)"
    }
  }, _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "23,4 23,9 28,9  "
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 7,
    y1: 12,
    x2: 13,
    y2: 12
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 7,
    y1: 16,
    x2: 13,
    y2: 16
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 7,
    y1: 20,
    x2: 13,
    y2: 20
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000008856896189156782520000016099320662591305127_",
    d: "M23.2,5L27,8.8V27H5V5H23.2z M23,3H5C3.9,3,3,3.9,3,5 v22c0,1.1,0.9,2,2,2h22c1.1,0,2-0.9,2-2V9.1c0-0.7-0.3-1.4-1-2l-3-3C24.4,3.3,23.7,3,23,3L23,3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000147903296622544205750000001111075717636954777_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000008856896189156782520000016099320662591305127_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000147903296622544205750000001111075717636954777_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000178167676469407661700000016288524181900036995_",
    x: 3,
    y: 3,
    width: 26,
    height: 26
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000049910113035053151300000015860682794881525421_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000178167676469407661700000016288524181900036995_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000049910113035053151300000015860682794881525421_)"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -2,
    className: "st4",
    width: 36,
    height: 36
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000103225215666381170960000007283593490372630715_",
    x: 15,
    y: 5,
    width: 2,
    height: 22
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000103225215666381170960000007283593490372630715_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000085957606210634002800000011835938091242428852_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000103225215666381170960000007283593490372630715_",
    style: {
      overflow: "visible"
    }
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginIllustration);
export default __webpack_public_path__ + "static/media/login-illustration.98c47954e0e3988f435b4756f830df9f.svg";
export { ForwardRef as ReactComponent };